import Prism from "prismjs";

import prismBash from "prismjs/components/prism-bash.min.js?raw";
import prismJson from "prismjs/components/prism-json.min.js?raw";
import prismLog from "prismjs/components/prism-log.min.js?raw";
import prismPython from "prismjs/components/prism-python.min.js?raw";
// Rolldown places prismjs core in the vendor chunk but our app code in a
// separate chunk. The CJS language components are IIFEs that reference
// the bare global `Prism`, which doesn't exist when the vendor chunk
// executes (the global assignment happens in our app chunk, loaded later).
//
// Fix: import language files as raw strings and evaluate them after
// setting the global. The ?raw suffix gives us the source text at build
// time without CJS/ESM conversion — sidestepping Rolldown's interop.
import prismR from "prismjs/components/prism-r.min.js?raw";
import prismSas from "prismjs/components/prism-sas.min.js?raw";
import prismSql from "prismjs/components/prism-sql.min.js?raw";
import prismYaml from "prismjs/components/prism-yaml.min.js?raw";

(typeof global !== "undefined" ? global : window).Prism = Prism;
[prismR, prismSas, prismPython, prismSql, prismBash, prismJson, prismYaml, prismLog].forEach(
  (src) => new Function(src)()
);

const SUPPORTED_LANGUAGES = ["r", "sas", "python", "sql", "bash", "json", "yaml", "log"] as const;

export type PrismLanguage = (typeof SUPPORTED_LANGUAGES)[number];

/**
 * Hook that provides PrismJS with all supported languages pre-loaded.
 */
const usePrismLanguages = (_languages?: PrismLanguage[]) => {
  return { isLoading: false, Prism };
};

export default usePrismLanguages;
